
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9lC86", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_PRESENCE_PAGE_STATE_KEYS", () => $30345a1bb3887a17$export$2fc66944d8ac2f6c);
const $30345a1bb3887a17$export$2fc66944d8ac2f6c = {
    PRESENCE_AVATAR_GROUP_DB_SPOTLIGHT_SEEN: 'database:databasePresenceAvatarGroupSpotlightSeen',
    PRESENCE_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN: 'page:pagePresenceAvatarGroupSpotlightSeen',
    TELEPOINTER_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN: 'page:pageTelepointerAvatarGroupSpotlightSeen'
};

});


//# sourceMappingURL=OnboardingStateEditor.7c189856.js.map
